/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PricingDto } from './PricingDto';
import {
    PricingDtoFromJSON,
    PricingDtoFromJSONTyped,
    PricingDtoToJSON,
    PricingDtoToJSONTyped,
} from './PricingDto';
import type { BreakdownCommissionDto } from './BreakdownCommissionDto';
import {
    BreakdownCommissionDtoFromJSON,
    BreakdownCommissionDtoFromJSONTyped,
    BreakdownCommissionDtoToJSON,
    BreakdownCommissionDtoToJSONTyped,
} from './BreakdownCommissionDto';
import type { GuaranteeBeneficiariesDto } from './GuaranteeBeneficiariesDto';
import {
    GuaranteeBeneficiariesDtoFromJSON,
    GuaranteeBeneficiariesDtoFromJSONTyped,
    GuaranteeBeneficiariesDtoToJSON,
    GuaranteeBeneficiariesDtoToJSONTyped,
} from './GuaranteeBeneficiariesDto';

/**
 * Guarantee breakdown within a payment schedule
 * @export
 * @interface BreakdownGuaranteeDto
 */
export interface BreakdownGuaranteeDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownGuaranteeDto
     */
    guaranteeId: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownGuaranteeDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownGuaranteeDto
     */
    designation: string;
    /**
     * 
     * @type {PricingDto}
     * @memberof BreakdownGuaranteeDto
     */
    pricing: PricingDto;
    /**
     * 
     * @type {GuaranteeBeneficiariesDto}
     * @memberof BreakdownGuaranteeDto
     */
    beneficiaries: GuaranteeBeneficiariesDto;
    /**
     * 
     * @type {Array<BreakdownCommissionDto>}
     * @memberof BreakdownGuaranteeDto
     */
    commissions: Array<BreakdownCommissionDto>;
}

/**
 * Check if a given object implements the BreakdownGuaranteeDto interface.
 */
export function instanceOfBreakdownGuaranteeDto(value: object): value is BreakdownGuaranteeDto {
    if (!('guaranteeId' in value) || value['guaranteeId'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    if (!('beneficiaries' in value) || value['beneficiaries'] === undefined) return false;
    if (!('commissions' in value) || value['commissions'] === undefined) return false;
    return true;
}

export function BreakdownGuaranteeDtoFromJSON(json: any): BreakdownGuaranteeDto {
    return BreakdownGuaranteeDtoFromJSONTyped(json, false);
}

export function BreakdownGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'guaranteeId': json['guaranteeId'],
        'code': json['code'],
        'designation': json['designation'],
        'pricing': PricingDtoFromJSON(json['pricing']),
        'beneficiaries': GuaranteeBeneficiariesDtoFromJSON(json['beneficiaries']),
        'commissions': ((json['commissions'] as Array<any>).map(BreakdownCommissionDtoFromJSON)),
    };
}

export function BreakdownGuaranteeDtoToJSON(json: any): BreakdownGuaranteeDto {
    return BreakdownGuaranteeDtoToJSONTyped(json, false);
}

export function BreakdownGuaranteeDtoToJSONTyped(value?: BreakdownGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guaranteeId': value['guaranteeId'],
        'code': value['code'],
        'designation': value['designation'],
        'pricing': PricingDtoToJSON(value['pricing']),
        'beneficiaries': GuaranteeBeneficiariesDtoToJSON(value['beneficiaries']),
        'commissions': ((value['commissions'] as Array<any>).map(BreakdownCommissionDtoToJSON)),
    };
}

